ACC.amdsmodalcontent = {

	_autoload: [
		"bindAMDSModalContentLink",
	],

	bindAMDSModalContentLink: function() {
		$(document).on("click", ".open-popin-conditions",function(e) {
			var that = $(this),
					type = that.data('type'),
					content = $('.popins-content .popin-' + type).html(),
					modalDialog = $('.popinConditions .modal-dialog'),
					modalBody = $('.popinConditions .modal-body'),
					modalBodyScroll = $('.popinConditions .modal-body-scroll');

			modalDialog.css('opacity', '0');
			modalBody.html(content);

			setTimeout(function() {
				var windowH = $(window).height();
				var modalBodyH = modalBody.height();
				var windowH65 = windowH * 0.65;

				console.log(windowH + ' ' + windowH65 + ' ' + modalBodyH);

				if(modalBodyH > windowH65) {
					modalBodyScroll.height(windowH65);
				} else {
					modalBodyScroll.removeAttr('style');
				}

				modalDialog.css('opacity', '1');
				modalBodyScroll.perfectScrollbar().scrollTop(0).perfectScrollbar('update');
			}, 400);

			//$.colorbox({closeButton:true});
			$('.modal-backdrop').hide();
		});
	}
}
